import { Box, Button, Center, Divider, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, FormControl, FormErrorMessage, } from "@reverb-ui/react";
import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
var OtpInputModal = function (_a) {
    var isOpen = _a.isOpen, onSubmit = _a.onSubmit, onClose = _a.onClose, onCancel = _a.onCancel, onRecoverPin = _a.onRecoverPin, error = _a.error, otpModalMode = _a.otpModalMode;
    var _b = useState(""), otp = _b[0], setOtp = _b[1];
    useEffect(function () {
        if (!isOpen)
            setOtp("");
    }, [isOpen]);
    var titleCancel = otpModalMode === "enableTfa" ? "Voltar" : "Cancel";
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null, "Two Factor Authentication"),
            React.createElement(ModalCloseButton, null),
            React.createElement(Divider, null),
            React.createElement(ModalBody, { overflow: "auto" },
                React.createElement(Center, { my: "8", flexDirection: "column" },
                    React.createElement("img", { src: "https://icons.iconarchive.com/icons/paomedia/small-n-flat/1024/lock-icon.png", width: "145px", height: "111px", alt: "Cancellation Request Icon", title: "Cancellation Request Icon" }),
                    React.createElement(Box, { mt: "5" },
                        React.createElement(OtpInput, { value: otp, onChange: setOtp, numInputs: 6, separator: "-", inputStyle: {
                                border: "1px solid black",
                                borderRadius: "3px",
                                fontSize: "20pt",
                            } }),
                        React.createElement(FormControl, { isInvalid: !!error, w: "100%", d: "flex", justifyContent: "center", pt: "3" },
                            React.createElement(FormErrorMessage, { textAlign: "center" }, error === null || error === void 0 ? void 0 : error.message))))),
            React.createElement(Divider, null),
            React.createElement(ModalFooter, null,
                React.createElement(Flex, { align: "center", justifyContent: "space-between", w: "full" },
                    React.createElement(Button, { borderColor: "blue.500", variant: "outline", colorScheme: "blue", color: "blue.500", onClick: onCancel, title: titleCancel }, titleCancel),
                    React.createElement(Box, null,
                        otpModalMode === "disableTfa" && (React.createElement(Button, { colorScheme: "blue", onClick: function () { return onRecoverPin(); }, title: "I lost my PIN code", variant: "outline", mr: 2 }, "I lost my PIN code")),
                        React.createElement(Button, { colorScheme: "blue", onClick: function () { return onSubmit(otp); }, title: "Confirm" }, "Confirm")))))));
};
export default OtpInputModal;
